export function gridFields() {
    return Object.freeze([{
      key: 'id',
      label: 'lbl.processOption.id',
      uneditable: true,
      notInTable: true,
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'name',
      label: 'lbl.processOption.name',
      filterable: true,
      sortable: true,
      required: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'locationId',
      label: 'lbl.processOption.locationId',     
      notInTable: true,
      uneditable: true,
      form: {
        type: 'dimSearch',
        url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
        config: {
          validate: "", // 参数检查，可以是正则表达式等
          bindId: 'processOptionLoc', // 绑定的 id, (id 相同的对象会被绑定)
          bindProp: "id", // 显示的属性的名称
          submitProp: "id" // 提交的属性
        }
      }
    },
    {
      key: 'locationName',
      label: 'lbl.processOption.locationName',  
      sortable: true,
      required: true, 
      form: {
        type: 'dimSearch',
        url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
        config: {
          validate: "", // 参数检查，可以是正则表达式等
          bindId: 'processOptionLoc', // 绑定的 id, (id 相同的对象会被绑定)
          bindProp: "locName", // 显示的属性的名称
          submitProp: "locName" // 提交的属性
        }
      }
    },
    {
      key: 'parentProcessOptionId',
      label: 'lbl.processOption.parentProcessOptionId',     
      notInTable: true,
      uneditable: true,
      form: {
        type: 'dimSearch',
        url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/processOption/findAll',
        config: {
          validate: "", // 参数检查，可以是正则表达式等
          bindId: 'parentProcessOption', // 绑定的 id, (id 相同的对象会被绑定)
          bindProp: "id", // 显示的属性的名称
          submitProp: "id" // 提交的属性
        }
      }
    },
    {
      key: 'parentProcessOptionName',
      label: 'lbl.processOption.parentProcessOptionName',      
      form: {
        type: 'dimSearch',
        url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/processOption/findAll',
        config: {
          validate: "", // 参数检查，可以是正则表达式等
          bindId: 'parentProcessOption', // 绑定的 id, (id 相同的对象会被绑定)
          bindProp: "name", // 显示的属性的名称
          submitProp: "name" // 提交的属性
        }
      }
    },
    {
      key: 'childProcessOptionId',
      label: 'lbl.processOption.childProcessOptionId',     
      notInTable: true,
      uneditable: true,
      form: {
        type: 'dimSearch',
        url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/processOption/findAll',
        config: {
          validate: "", // 参数检查，可以是正则表达式等
          bindId: 'childProcessOption', // 绑定的 id, (id 相同的对象会被绑定)
          bindProp: "id", // 显示的属性的名称
          submitProp: "id" // 提交的属性
        }
      }
    },
    {
      key: 'childProcessOptionName',
      label: 'lbl.processOption.childProcessOptionName',      
      form: {
        type: 'dimSearch',
        url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/processOption/findAll',
        config: {
          validate: "", // 参数检查，可以是正则表达式等
          bindId: 'childProcessOption', // 绑定的 id, (id 相同的对象会被绑定)
          bindProp: "name", // 显示的属性的名称
          submitProp: "name" // 提交的属性
        }
      }
    }
    ]);
  }
  
  function nextYear() {
    const current = new Date;
    return new Date(current.getFullYear() + 1, current.getMonth(), current.getDate())
  }
  
  // class
  export const ProcessOption = function () {
    gridFields().forEach(item => {
      this[item.key] = item.default || '';
    })
  }
  
  
  export const filter = gridFields()
    .filter(v => v.filterable)
    .reduce((tar, v) => {
      tar[`${v.key}Filter`] = v.default || '';
      return tar
    }, {})
  export const filterFields = gridFields().filter(v => v.filterable).map(v => `filter.${v.key}`)